import {SoundMetadata} from '../model/SoundMetadata'

export function generateSoundFileName(publicSoundAddress: string, metadata?: SoundMetadata) {
  // TODO MP3 extension hard-coded. Still have to find a way to determine audio format.
  const extension = 'mp3'
  const baseName = publicSoundAddress.replace(/[^a-z0-9]/gi, '_').toLowerCase()
  return `${baseName}.${extension}`
}